import { StringKeys } from "../../resources/strings/StringKeys";

export const translateReviewCycle = (reviewCycle, t) => {
    if (!reviewCycle) return '';
    
    const [year, period] = reviewCycle.split('_');
    
    switch(period) {
        case 'Q1':
            return `${t(StringKeys.Q1)} ${year}`;
        case 'Q2':
            return `${t(StringKeys.Q2)} ${year}`;
        case 'Q3':
            return `${t(StringKeys.Q3)} ${year}`;
        case 'Q4':
            return `${t(StringKeys.Q4)} ${year}`;
        case 'ANNUAL':
            return `${t(StringKeys.ANNUAL)} ${year}`;
        default:
            return reviewCycle;
    }
}; 